import GetWebAppointmentListRequestModelBase from '../_generated/modelBases/get-web-appointment-list-request-model-base';

export default class GetWebAppointmentListRequestModel extends GetWebAppointmentListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
